import axios from "axios";
import { getToken, userId } from "./LocalStorage";

const baseUrl = process.env.REACT_APP_COMMON_URL + "vms/mms";
const baseUrlBlob = process.env.REACT_APP_COMMON_URL;

export const executePost = async (endPoint, data) => {
  const Auth_Token = getToken();
  const mms_city_id = userId();
  return await axios.post(baseUrl + endPoint, data, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Token: Auth_Token,
      Marketplace: mms_city_id,
    },
  });
};

export const executeGET = async (endPoint) => {
  const Auth_Token = getToken();
  const mms_city_id = userId();
  return await axios.get(baseUrl + endPoint, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Token: Auth_Token,
      Marketplace: mms_city_id,
    },
  });
};

export const ExportExecutePost = async (endPoint, data) => {
  const Auth_Token = getToken();
  const mms_city_id = userId();
  return await axios.post(baseUrl + endPoint, data, {
    responseType: "blob",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Token: Auth_Token,
      Marketplace: mms_city_id,
    },
  });
};

export const ExportExecutePostBlob = async (endPoint) => {
  const Auth_Token = getToken();
  const mms_city_id = userId();
  return await axios.get(baseUrlBlob + endPoint, {
    responseType: "blob",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Token: Auth_Token,
      Marketplace: mms_city_id,
    },
  });
};
